import { EntityVm } from 'api/core/entity.vm';
import { IsEnum, IsString } from 'class-validator';

export enum OrdersStatus {
  PENDING = 'PENDING',
  CLOSED = 'CLOSED',
}

export class OrderVm extends EntityVm {
  @IsString()
  serieId: string;

  @IsString()
  orderDate: Date;

  @IsString()
  supplierId: string;

  @IsString()
  supplierName: string;

  @IsString()
  observations: string;

  @IsEnum(OrdersStatus)
  status: OrdersStatus;
}
